var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HelloWorld',{attrs:{"payment-request-id":this.paymentRequestId,"without-id-verification":this.withoutIdVerification}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }